import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function CommercialPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            特定商取引法に基づく表示
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            ボラタスサービスに関する特定商取引法に基づく表示事項
          </p>
          <div className="w-24 h-1 bg-teal-500 mx-auto"></div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-8">
            
            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">販売事業者名</h2>
              <p className="text-gray-700 leading-relaxed">
                財恩工房（個人事業）／ボラタス運営事務局
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">運営統括責任者</h2>
              <p className="text-gray-700 leading-relaxed">
                村濱 興仁
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">所在地</h2>
              <p className="text-gray-700 leading-relaxed">
                埼玉県（詳細な住所は、ご請求があれば遅滞なく電子メール等で提供いたします）
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">電話番号</h2>
              <div className="text-gray-700 leading-relaxed">
                <p className="mb-2">電話番号は、ご請求があれば遅滞なく電子メール等で提供いたします。</p>
                <p className="text-sm text-gray-600">
                  ※お問い合わせは原則メールにてお願いいたします。
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">連絡先（メール）</h2>
              <p className="text-gray-700 leading-relaxed">
                info@zion-draft.work
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">お問い合わせ受付時間</h2>
              <div className="text-gray-700 leading-relaxed">
                <p className="mb-2">平日 9:00〜18:00（土日祝日を除く）</p>
                <p className="text-sm text-gray-600">
                  ※メールは24時間受け付けていますが、返信は原則営業時間内に行います。
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">サービス内容</h2>
              <p className="text-gray-700 leading-relaxed">
                学習支援における「居場所」と「ボランティア（講師）」のマッチングサービス「ボラタス」の提供（オンライン学習支援、学習サポートの実施・運営、関連機能の提供を含みます）
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">販売価格（ポイント）</h2>
              <div className="text-gray-700 leading-relaxed">
                <p className="mb-4">ポイントを購入してサービスを利用します。1ポイント＝1円（税込）。15分ごとに600ポイント消費します。</p>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>600ポイント：¥600（税込）／15分</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>1,200ポイント：¥1,200（税込）／30分</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>2,400ポイント：¥2,400（税込）／60分</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>12,000ポイント：¥12,000（税込）／5時間</span>
                  </li>
                </ul>
                <p className="text-sm text-gray-600">
                  ※価格・販売内容は予告なく変更される場合があります。
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">支払方法</h2>
              <div className="text-gray-700 leading-relaxed">
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>クレジットカード（Visa / Mastercard / American Express / JCB など）</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>デビットカード</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>決済処理：Stripe, Inc.</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">商品（ポイント）の引渡時期</h2>
              <p className="text-gray-700 leading-relaxed">
                決済完了後、即時にポイントがアカウントへ反映されます。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">返品・交換・キャンセル</h2>
              <div className="text-gray-700 leading-relaxed">
                <div className="mb-4">
                  <p className="font-semibold mb-2">【返品・交換】</p>
                  <p>デジタルコンテンツ（ポイント）の性質上、決済完了後の返品・交換は原則お受けできません。</p>
                </div>
                <div className="mb-4">
                  <p className="font-semibold mb-2">【キャンセル】</p>
                  <p>決済完了前であればキャンセル可能です。決済完了後のキャンセルは原則お受けできません。</p>
                </div>
                <div>
                  <p className="font-semibold mb-2">【例外的な返金対応】</p>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>システム障害等により正常にポイント反映／利用ができない場合</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>当方の責に帰すべき事由によりサービス提供ができない場合</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>その他、当方が特別に認める場合</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">免責事項</h2>
              <div className="text-gray-700 leading-relaxed">
                <p className="mb-4">
                  当事業者は、以下について一切の責任を負いません（ただし法令上免責が認められない場合を除きます）。
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>利用者間（居場所・ボランティア・学習者等）のトラブル</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>システムの一時停止・障害・通信環境等に起因する損害</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>天災地変その他の不可抗力による損害</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-teal-50 border border-teal-200 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">その他</h2>
              <div className="text-gray-700 leading-relaxed">
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>本表記は、特定商取引法第11条に基づく表記です。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>サービス内容の詳細は利用規約をご確認ください。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                    <span>個人情報の取り扱いについてはプライバシーポリシーをご確認ください。</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
